import React from 'react';
import {useStepActions, useStepStore} from "react-step-machine";
import {useFormikContext} from "formik";


const ActionButtons = () => {
    const { isSubmitting, isValid, submitForm, setSubmitting, setTouched, errors } = useFormikContext();

    const {nextStep, previousStep} = useStepActions();
    const {totalSteps, activeStep} = useStepStore();

    const firstStep = activeStep === 1;
    const lastStep = activeStep === totalSteps;

    const handleNext = async () => {
        const res = await submitForm();
        // console.log("Submit result:", res);
        if (!res) return;
        if (!isValid) return;
        setTouched({});
        setSubmitting(false);
        if (!lastStep) nextStep();
    }

    return (
        <>
            <div  className="actionButtons">
                {!firstStep &&
                    <button
                        onClick={previousStep}
                        className="btn btn-outline-secondary"
                    >Back</button>}
                <button
                    type="button"
                    className="btn btn-outline-primary"
                    onClick={handleNext}
                    disabled={ isSubmitting}
                >
                    {lastStep ? "Submit" : "Next"}
                </button>
                {/*{JSON.stringify(errors,null, 2)}*/}
            </div>
        </>


    )
}

export default ActionButtons;